import React from 'react';
type Testimonial = {
  name: string;
  location: string;
  quote: string;
  initials: string;
  color: string;
};
const testimonials: Testimonial[] = [{
  name: 'Marc D.',
  location: 'Paris',
  quote: "Avant, je passais des heures à chercher des workouts. Aujourd'hui, j'ouvre le système et mes classes sont prêtes.",
  initials: 'MD',
  color: '#F25C25'
}, {
  name: 'Julie T.',
  location: 'Lyon',
  quote: 'Les sections mobility et women functional ont complètement changé mon coaching.',
  initials: 'JT',
  color: '#FFB627'
}, {
  name: 'Anthony R.',
  location: 'Marseille',
  quote: "Ce n'est pas un simple PDF. On dirait une vraie plateforme professionnelle.",
  initials: 'AR',
  color: '#16A34A'
}, {
  name: 'Lucas M.',
  location: 'Toulouse',
  quote: 'Mes classes small group sont beaucoup plus dynamiques maintenant.',
  initials: 'LM',
  color: '#F25C25'
}, {
  name: 'Emma C.',
  location: 'Bordeaux',
  quote: "Moins de chaos. Plus de structure. Plus d'énergie.",
  initials: 'EC',
  color: '#FFB627'
}, {
  name: 'Thomas B.',
  location: 'Nantes',
  quote: 'Les 100 WOD prêts ont changé ma façon de programmer. Je gagne des heures chaque semaine.',
  initials: 'TB',
  color: '#16A34A'
}];
export function TestimonialsSection() {
  return <section id="testimonials" className="w-full bg-bg-dark py-16 sm:py-24 px-4 relative overflow-hidden border-y border-border-light" data-id="element-269">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[600px] h-[400px] bg-primary/8 rounded-full blur-[120px] pointer-events-none hidden sm:block" data-id="element-270"></div>

      <div className="max-w-6xl mx-auto relative z-10" data-id="element-271">
        <div className="text-center mb-10 sm:mb-14" data-id="element-272">
          <p className="text-primary font-display font-bold uppercase tracking-[0.2em] text-xs sm:text-sm mb-3" data-id="element-273">
            ⭐ Avis Réels
          </p>
          <h2 className="font-display text-3xl sm:text-5xl font-bold text-white mb-4 tracking-tight uppercase" data-id="element-274">
            Ce que disent les coachs{' '}
            <span className="text-primary" data-id="element-275">francophones</span>.
          </h2>
          <div className="flex items-center justify-center gap-2 mt-4" data-id="element-276">
            <span className="text-secondary text-base sm:text-lg" data-id="element-277">
              ⭐⭐⭐⭐⭐
            </span>
            <span className="text-text-sec text-sm sm:text-base font-medium" data-id="element-278">
              4.9/5 (+1.200 Avis Vérifiés)
            </span>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 sm:gap-6" data-id="element-279">
          {testimonials.map((t, i) => <article key={i} className="bg-bg-alt border border-border-light rounded-sm p-6 sm:p-7 flex flex-col relative hover:border-primary/40 transition-colors group overflow-hidden" data-id="element-280">
              <div className="absolute top-0 left-0 w-full h-1 bg-primary/30 group-hover:bg-primary transition-colors" data-id="element-281"></div>

              <span aria-hidden="true" className="absolute top-3 right-5 font-display text-6xl font-bold text-primary/15 leading-none select-none" data-id="element-282">
                "
              </span>

              <div className="text-secondary text-sm mb-3" data-id="element-283">⭐⭐⭐⭐⭐</div>

              <p className="text-white text-[15px] sm:text-base leading-relaxed font-medium mb-5 flex-grow italic" data-id="element-284">
                "{t.quote}"
              </p>

              <div className="flex items-center gap-3 pt-4 border-t border-border-light" data-id="element-285">
                <div className="w-11 h-11 rounded-sm flex items-center justify-center text-white font-display font-bold text-sm flex-shrink-0" style={{
              backgroundColor: t.color
            }} aria-hidden="true" data-id="element-286">
                  {t.initials}
                </div>
                <div className="min-w-0" data-id="element-287">
                  <p className="text-white font-bold text-sm truncate" data-id="element-288">
                    — {t.name}
                  </p>
                  <p className="text-text-sec text-xs truncate" data-id="element-289">
                    📍 {t.location}
                  </p>
                </div>
              </div>
            </article>)}
        </div>

        <p className="text-center text-text-sec text-sm sm:text-base font-medium mt-10 sm:mt-12" data-id="element-290">
          Plus de <span className="text-primary font-bold" data-id="element-291">18.000 coachs</span>{' '}
          dans le monde s'entraînent déjà avec FUNCTIONAL CLÉ EN MAIN.
        </p>
      </div>
    </section>;
}